// Builds schema.org JSON-LD for listing pages: CollectionPage + BreadcrumbList + ItemList.

const SITE_URL = "https://www.extremeperformance.com";
const WEBSITE_ID = `${SITE_URL}/#website`;
const ORGANIZATION_ID = `${SITE_URL}/#organization`;

// breadcrumb = [{ name, url }, ...] from Home to the current page
// items = [{ url, name? }, ...] shown on the page, in display order
export const buildCollectionPageSchema = ({ name, url, description, breadcrumb, items }) => {
    if (!name || !url) return null;

    const page = {
        "@type": "CollectionPage",
        "@id": `${url}#page`,
        url,
        name,
        isPartOf: { "@id": WEBSITE_ID },
        about: { "@id": ORGANIZATION_ID },
    };
    if (description) page.description = description;

    const graph = [page];

    if (breadcrumb && breadcrumb.length > 0) {
        graph.push({
            "@type": "BreadcrumbList",
            itemListElement: breadcrumb.map((crumb, index) => ({
                "@type": "ListItem",
                position: index + 1,
                name: crumb.name,
                item: crumb.url,
            })),
        });
    }

    const listItems = (items || []).filter((item) => item && item.url);
    if (listItems.length > 0) {
        graph.push({
            "@type": "ItemList",
            itemListElement: listItems.map((item, index) => {
                const listItem = { "@type": "ListItem", position: index + 1, url: item.url };
                if (item.name) listItem.name = item.name;
                return listItem;
            }),
        });
    }

    return { "@context": "https://schema.org", "@graph": graph };
};

export const collectionBreadcrumb = (name, url) => [
    { name: "Home", url: `${SITE_URL}/` },
    { name, url },
];
